import React from 'react';
import { Table } from 'react-bootstrap';
import PeopleEngagementTableRow from './PeopleEngagementTableRow.jsx';

const PeopleEngagementTable = ({ data }) => {
  const renderData = (items, depth = 0) => {
    return items.map((item) => (
      <PeopleEngagementTableRow
        key={item.id}
        item={item}
        depth={depth}
        renderChildren={renderData}
      />
    ));
  };

  return (
    <Table className="table-condensed" hover>
      <thead>
        <tr>
          <th>Group</th>
          <th>Readiness</th>
          <th>Communication</th>
          <th>Training</th>
          <th>Sustainment</th>
          <th>Feedback Forms</th>
          <th>Feedback Engagement</th>
          <th>Completion</th>
        </tr>
      </thead>
      <tbody>
        {renderData(data)}

        {/*Prevent table jumping while search or empty*/}
        <tr>
          <td style={{ border: 'none' }}></td>
          <td style={{ border: 'none' }}></td>
          <td style={{ border: 'none' }}></td>
          <td style={{ border: 'none' }}></td>
          <td style={{ border: 'none' }}></td>
          <td style={{ border: 'none' }}></td>
          <td style={{ border: 'none' }}></td>
          <td style={{ border: 'none' }}></td>
        </tr>
        {/*Prevent table jumping while search or empty*/}
      </tbody>
    </Table>
  );
};

export default PeopleEngagementTable;
